const fontFamilyFallback = `'Arial', 'Trebuchet MS', sans-serif`;
/**
 * https://lineto.com/typefaces/circular
 */ const fontFamilyBook = `'Circular-Book', ${fontFamilyFallback}`;
const fontFamilyBookItalic = `'Circular-Italic', ${fontFamilyFallback}`;
const fontFamilyMedium = `'Circular-Medium', ${fontFamilyFallback}`;
const fontFamilyMediumItalic = `'Circular-Italic-Medium', ${fontFamilyFallback}`;
const fontFamilyBold = `'Circular-Bold', ${fontFamilyFallback}`;
/** Help text, h6 uppercase */ const fontSizeXxSmall = 12;
/** Tooltips */ const fontSizeXSmall = 13;
/** Buttons, labels, paragraphs, h5 */ const fontSizeSmall = 14;
/** h4 */ const fontSizeMedium = 16;
/** h3 */ const fontSizeLarge = 18;
/** h2 */ const fontSizeXLarge = 28;
/** h1 */ const fontSizeXxLarge = 40;
const fontWeightBook = 400;
const fontWeightMedium = 500;
const fontWeightBold = 700;

export { fontFamilyBold, fontFamilyBook, fontFamilyBookItalic, fontFamilyFallback, fontFamilyMedium, fontFamilyMediumItalic, fontSizeLarge, fontSizeMedium, fontSizeSmall, fontSizeXLarge, fontSizeXSmall, fontSizeXxLarge, fontSizeXxSmall, fontWeightBold, fontWeightBook, fontWeightMedium };
//# sourceMappingURL=fonts.js.map
